
import Vue from "vue";

const TenantAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED TENANT API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchTenants() {
    if (config) {   
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const url = `${config.TENET_SERVICE}/tenants/?list=true`;
        const request = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
        });
        try {
            const response = await fetch(request);
            if (response.status === 403) {
              return;
            }
            if (response.status == 401) {
              return;
            }
            if (response.status == 503) {
              return this.fetchTenants();
            }
            if (response.status != 200) {
                return;
            } else {
              const data = await response.json();
              return data;
            }
        } catch (dex) {
            console.error("failed to get devices", dex);
        }
    }
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$TenantAPIService) {
  Vue.prototype.$TenantAPIService = new TenantAPIService();
}

export default Vue.prototype.$TenantAPIService;
